import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CompanyService from "../../../Services/CompanyService";
import { Link, useNavigate } from "react-router-dom";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import DataParser from "../../../utlits/Dataparser";
import StatusBadge from "../../Reuseable/StatusBadge";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import WorkFromHomeStatus from "../../Reuseable/WorkFromHomeStatus";
import { Tooltip, message } from "antd";
import DepartmentServices from "../../../Services/DepartmentServices";
import JobStatusService from "../../../Services/JobStatusService";
import SocketService from "../../../Services/SocketService";
import { PiUserCheckBold } from "react-icons/pi";
import LeaveEntitlementService from "../../../Services/LeaveEntitlementService";

message.config({ zIndex: 1000000001 });

const Users = () => {
  const navigate = useNavigate();
  const [user, setUsers] = useState([]);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isfulled, setIsFulled] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(15);
  const [departments, setDepartments] = useState([]);
  const [roles, setRoles] = useState([]);
  const [jobStatuses, setJobStatuses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [missingData, setMissingData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);

  const getData = () => {
    setIsLoading(true);
    const companyId = DataParser.CompanyId();
    CompanyService.getComapnyUser(companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          localStorage.removeItem("admins");
          return;
        }
        if (res.Good === true) {
          setUsers(res.data.user);
          if (DataParser.AllowedCompanyUsers() <= res.data.user.length) {
            setIsFulled(true);
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 500) {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          localStorage.removeItem("admins");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  useEffect(() => {
    getData();
    const companyId = DataParser.CompanyId();

    DepartmentServices.getCompanyDepartment(companyId).then((res) => {
      setDepartments(res.data.departments || []);
    });

    CompanyService.getCompanyRoles(companyId).then((res) => {
      setRoles(res.data.roles || []);
    });

    JobStatusService.getJobStatusService(companyId).then((res) => {
      setJobStatuses(res.data.jobstatus || []);
    });

    setuserPermissions(DataParser.CompanyUserPermissions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();

    const handleUserUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) getData();
    };
    const handleDepartmentUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        DepartmentServices.getCompanyDepartment(companyId).then((res) => {
          setDepartments(res.data.departments || []);
        });
      }
    };
    const handleRoleUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        CompanyService.getCompanyRoles(companyId).then((res) => {
          setRoles(res.data.roles || []);
        });
      }
    };
    const handleJobStatusUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        JobStatusService.getJobStatusService(companyId).then((res) => {
          setJobStatuses(res.data.jobstatus || []);
        });
      }
    };

    SocketService.on("user_update", handleUserUpdate);
    SocketService.on("department_update", handleDepartmentUpdate);
    SocketService.on("role_update", handleRoleUpdate);
    SocketService.on("jobstatus_update", handleJobStatusUpdate);

    return () => {
      SocketService.off("user_update", handleUserUpdate);
      SocketService.off("department_update", handleDepartmentUpdate);
      SocketService.off("role_update", handleRoleUpdate);
      SocketService.off("jobstatus_update", handleJobStatusUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handelEditItem = (e, item) => {
    e.preventDefault();
    navigate(`/${DataParser.CompanyIdentifierRole()}/users/${item.id}`);
  };

  const handelViewItem = (e, item) => {
    e.preventDefault();
    navigate(`/${DataParser.CompanyIdentifierRole()}/users/view/${item.id}`);
  };

  const handleAddEmployee = (e) => {
    e.preventDefault();
    const missingItems = [];
    if (departments.length === 0)
      missingItems.push({ name: "Departments", path: `/${DataParser.CompanyIdentifierRole()}/departments` });
    if (roles.length === 0)
      missingItems.push({ name: "Roles", path: `/${DataParser.CompanyIdentifierRole()}/roles` });
    if (jobStatuses.length === 0)
      missingItems.push({ name: "Employee Job Status", path: `/${DataParser.CompanyIdentifierRole()}/employeejob` });

    if (missingItems.length > 0) {
      setMissingData(missingItems);
      setShowModal(true);
    } else {
      navigate(`/${DataParser.CompanyIdentifierRole()}/users/create`);
    }
  };

  const filteredUsers = user.filter((u) => {
    const search = searchText.toLowerCase();
    const fullName = `${u.first_name} ${u.last_name}`.toLowerCase();
    return (
      String(u.id).includes(search) ||
      (u.email && u.email.toLowerCase().includes(search)) ||
      fullName.includes(search) ||
      (u.departments?.name && u.departments.name.toLowerCase().includes(search)) ||
      (u.roles?.name && u.roles.name.toLowerCase().includes(search))
    );
  });
  
  const handelCheckAttendance = (e, s) => {
    e.preventDefault();
    const compId = DataParser.CompanyId();
    LeaveEntitlementService.getEntitlementeEmployeeGet(s.id, compId).then((res) => {
      if (res.data && res.data.length > 0) {
        const name = `${s.first_name} ${s.last_name}`;
        navigate(`/${DataParser.CompanyIdentifierRole()}/employee-attendance`, {
          state: { data: s.id, name: name },
        });
      } else {
        setShowAttendanceModal(true);
      }
    }).catch(err => {
      console.error("Policy check error:", err);
      setShowAttendanceModal(true);
    });
  };

  const PaginatedData = paginate(filteredUsers, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>All Employees - Planit</title>
      </Helmet>

      {/* Pre-requisites Missing Modal */}
      {showModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={() => setShowModal(false)}>
          <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Pre-requisites Missing</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "10px" }}>
                  Please add the following first before creating an employee:
                </p>
                <ul style={{ listStyleType: "none", paddingLeft: 0, marginBottom: 0 }}>
                  {missingData.map((item, index) => (
                    <li key={index} style={{ marginBottom: "8px", fontSize: "13px" }}>
                      <i className="uil uil-exclamation-triangle me-2" style={{ color: "#ff4d4f" }} />
                      <Link
                        to={item.path}
                        onClick={() => setShowModal(false)}
                        style={{ color: "#0DDFAB", fontWeight: 600, textDecoration: "underline" }}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light"
                  style={{ borderRadius: "5px", fontSize: "13px" }}
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-center justify-content-between" style={{ padding: "0 0 12px 0" }}>
                  {/* Search bar */}
                  <div className="float-input-wrap float-input-icon" style={{ width: "300px", position: "relative" }}>
                    <i className="uil-search" style={{
                      position: "absolute", right: "14px", top: "50%",
                      transform: "translateY(-50%)", color: "#D2D2D2", fontSize: "15px", pointerEvents: "none", zIndex: 2,
                    }} />
                    <input
                      type="text"
                      className="form-control-custom-focus"
                      placeholder=" "
                      value={searchText}
                      style={{
                        padding: "0 38px 0 14px",
                        borderRadius: "5px",
                        height: "34px",
                        border: "1.5px solid #F2F2F2",
                        lineHeight: "34px",
                        margin: 0,
                        width: "100%",
                      }}
                      onChange={(e) => { setSearchText(e.target.value); setCurrentPage(1); }}
                    />
                    <label style={{ fontSize: "13px", left: "14px" }}>Search by ID, Name, Dept, or Role...</label>
                    {searchText && (
                      <i
                        className="uil-times"
                        onClick={() => { setSearchText(""); setCurrentPage(1); }}
                        style={{
                          position: "absolute", right: "36px", top: "50%",
                          transform: "translateY(-50%)", color: "#aaa",
                          fontSize: "16px", cursor: "pointer", zIndex: 2,
                        }}
                      />
                    )}
                  </div>
                  {/* Breadcrumbs + Add button */}
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Employees</li>
                    </ol>
                    {userPermissions.indexOf("user-create") !== -1 && !isfulled && (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        onClick={handleAddEmployee}
                      >
                        Add Employee
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">

                    <style>{`
                        .float-input-wrap label {
                            top: 50% !important;
                            transform: translateY(-50%) !important;
                            transition: all 0.2s ease !important;
                            color: #D2D2D2 !important;
                        }
                        .float-input-wrap input:focus ~ label,
                        .float-input-wrap input:not(:placeholder-shown) ~ label {
                            top: 0px !important;
                            font-size: 11px !important;
                            background: #fff !important;
                        }
                        .form-control-custom-focus:focus {
                            border-color: #1D1D1D !important;
                            box-shadow: none !important;
                            outline: none !important;
                        }
                        .float-input-wrap input {
                            height: 34px !important;
                            margin: 0 !important;
                        }

                        /* Hover / focus on search input */
                        .float-input-wrap:hover input,
                        .float-input-wrap:focus-within input {
                            border-color: #1D1D1D !important;
                        }
                        .float-input-wrap:hover label,
                        .float-input-wrap:focus-within label {
                            color: #1D1D1D !important;
                        }
                        .float-input-wrap:hover i,
                        .float-input-wrap:focus-within i {
                            color: #1D1D1D !important;
                        }

                        /* Table no-scroll */
                        .listing-table { table-layout: fixed; width: 100%; min-width: 900px; }
                        .listing-table th, .listing-table td { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
                        .listing-table th:nth-child(1), .listing-table td:nth-child(1) { width: 5%; }
                        .listing-table th:nth-child(2), .listing-table td:nth-child(2) { width: 17%; }
                        .listing-table th:nth-child(3), .listing-table td:nth-child(3) { width: 11%; }
                        .listing-table th:nth-child(4), .listing-table td:nth-child(4) { width: 13%; }
                        .listing-table th:nth-child(5), .listing-table td:nth-child(5) { width: 15%; }
                        .listing-table th:nth-child(6), .listing-table td:nth-child(6) { width: 11%; }
                        .listing-table th:nth-child(7), .listing-table td:nth-child(7) { width: 9%; }
                        .listing-table th:nth-child(8), .listing-table td:nth-child(8) { width: 7%; }
                        .listing-table th:nth-child(9), .listing-table td:nth-child(9) { width: 12%; }
                        .listing-table-wrapper { overflow-x: auto; }
                        .table-body-wrapper { position: relative; }
                        .table-loader-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.75); display: flex; align-items: center; justify-content: center; z-index: 10; min-height: 60px; }
                        .table-body-wrapper { position: relative; }
                        .table-loader-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.75); display: flex; align-items: center; justify-content: center; z-index: 10; min-height: 60px; }
                      `}</style>

                    <div className="listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>ID</th>
                            <th>Email</th>
                            <th>Department</th>
                            <th>Name</th>
                            <th>Creation Date</th>
                            <th>Role</th>
                            <th>Status</th>
                            <th>WFH</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                      </table>
                      <div className="table-body-wrapper">
                        <table className="table mb-0 custom-table listing-table">
                          <colgroup>
                            <col style={{ width: "5%" }} />
                            <col style={{ width: "17%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "13%" }} />
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "9%" }} />
                            <col style={{ width: "7%" }} />
                            <col style={{ width: "12%" }} />
                          </colgroup>
                          <tbody>
                            {isLoading ? <TableSkeleton cols={9} rows={6} /> : PaginatedData && PaginatedData.length > 0 ? (
                              PaginatedData.map((item) => (
                              <tr key={item.id}>
                                <td style={{ verticalAlign: "middle" }}>{item.id}</td>
                                <td style={{ verticalAlign: "middle" }}>{item.email}</td>
                                <td style={{ verticalAlign: "middle" }}>{item.departments?.name}</td>
                                <td style={{ verticalAlign: "middle" }}>{item.first_name} {item.last_name}</td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {(item.created_at || item.createdAt) ? (
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                      <i className="uil uil-calendar-alt" style={{ color: "#0DDFAB", fontSize: "16px", flexShrink: 0 }} />
                                      {moment(item.created_at || item.createdAt).format("D, MMMM YYYY")}
                                    </span>
                                  ) : "—"}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>{item.roles?.name}</td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {userPermissions.indexOf("user-edit") !== -1 && item.roles?.name !== "Company Admin" ? (
                                    <StatusBadge item={item} api={CompanyService.changeUserStatus} />
                                  ) : (
                                    <span className={`btn btn-${item.status === 1 ? "success" : "danger"} waves-effect waves-light btn-sm`}>
                                      {item.status === 1 ? "Published" : "Draft"}
                                    </span>
                                  )}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {userPermissions.indexOf("user-edit") !== -1 ? (
                                    <WorkFromHomeStatus item={item} api={CompanyService.updateStatusWorkFromHome} />
                                  ) : (
                                    <span className={`btn btn-${item.wrokfrom_home === 1 ? "success" : "danger"} waves-effect waves-light btn-sm`}>
                                      {item.wrokfrom_home === 1 ? "Yes" : "No"}
                                    </span>
                                  )}
                                </td>
                                <td className="tableset" style={{ verticalAlign: "middle" }}>
                                  {userPermissions.indexOf("user-edit") !== -1 ? (
                                    <Link to="#" className="cursor-pointer iconscolor" onClick={(e) => handelEditItem(e, item)}>
                                      <Tooltip title="Edit Employee">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <Tooltip title="You don't have permission to edit">
                                      <span className="uil-pen iconscolor text-muted" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                    </Tooltip>
                                  )}
                                  <Link to="#" className="cursor-pointer iconscolor" onClick={(e) => handelViewItem(e, item)}>
                                    <Tooltip title="View Employee">
                                      <i className="uil-eye iconscolor" />
                                    </Tooltip>
                                  </Link>
                                  <Link to="#" className="cursor-pointer iconscolor" onClick={(e) => handelCheckAttendance(e, item)}>
                                    <Tooltip title="View Attendance">
                                      <i className="uil-user-check iconscolor" />
                                    </Tooltip>
                                  </Link>
                                </td>
                              </tr>
                            ))
                            ) : !isLoading ? (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  No employee records found.
                                </td>
                              </tr>
                            ) : (
                              <tr><td colSpan="9" style={{ height: "60px" }}></td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {filteredUsers.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={filteredUsers.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAttendanceModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={() => setShowAttendanceModal(false)}>
          <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>No Policy Assigned</h5>
                <button type="button" className="btn-close" onClick={() => setShowAttendanceModal(false)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: 0 }}>
                  No policy is assigned to this user. Please assign a policy first to view attendance.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-primary waves-effect waves-light" style={{ borderRadius: "5px", fontSize: "13px" }} onClick={() => setShowAttendanceModal(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Users;
